/** Runtime config. Defaults keep the connector fully functional in DEMO mode so
 *  it's testable without a trunk; a deployment can drop a /config.json to switch
 *  the telephony provider to the real voice edge. */
export interface CtiConfig {
  provider: "demo" | "livekit";
  agentIdentity: string;
  livekit: { dialUrl: string; hangupUrl: string; agentApiBase: string };
}

const DEFAULTS: CtiConfig = {
  provider: "demo",
  // For inbound (ACD) this MUST be a real orchestrator agent id that belongs to the
  // routed queue, so offers are delivered to this softphone.
  agentIdentity: "cti-agent",
  livekit: {
    dialUrl: "/api/edge/cti/dial",
    hangupUrl: "/api/edge/cti/hangup",
    agentApiBase: "/api/edge/agent/api",
  },
};

let cache: CtiConfig | null = null;

export async function loadConfig(): Promise<CtiConfig> {
  if (cache) return cache;
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (res.ok) {
      const j = (await res.json()) as Partial<CtiConfig>;
      cache = { ...DEFAULTS, ...j, livekit: { ...DEFAULTS.livekit, ...(j.livekit ?? {}) } };
      return cache;
    }
  } catch {
    /* no config.json → demo defaults */
  }
  cache = DEFAULTS;
  return cache;
}
